// Classes.
import {BooleanLocatorComponent} from './boolean.locator-component';


export class WithResultsLocatorComponent extends BooleanLocatorComponent {

  public constructor(_value: boolean = false) {
    super(_value);
  };

  public toString(): string {
    let str: string;

    if(this._value === null) {
      str = 'bothRes';
    }
    else if (this._value === true)     {
      str = 'wRes';
    }
    else {
      str = 'woutRes';
    }

    return str;
  }

  setOnlyWithoutResults() {
    this._value = false;
  }

  setOnlyWithResults() {
    this._value = true;
  }

  setBothWithOrWithoutResults() {
    this._value = null;
  }
}

